var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon-reviews-star",attrs:{"color":"#e1cd9d","icon":"star","size":"lg"}})}
var staticRenderFns = []

export { render, staticRenderFns }